import { CardBrand, BankAccountDetails, Feature } from '@afterpay/types'
import { CardDetails, CheckoutPaymentSchedule } from '@afterpaytouch/portal-api'
import { EnrichedCardDetails, EnrichedBankAccountDetails, lastPaymentDate } from '../model'
import { enrichBankAccount, PreferredBankAccount, selectPreferredBankAccount } from './bank-account'
import { PreferredCard, enrichCard, selectPreferredCard } from './credit-card'

interface EnrichedCardsAndBankAccounts {
  enrichedCards: EnrichedCardDetails[]
  enrichedBankAccounts: EnrichedBankAccountDetails[]
  enrichedPreferredCard: PreferredCard
  enrichedPreferredBankAccount: PreferredBankAccount
}

interface EnrichedCardsAndBankAccountsParams {
  savedCards: CardDetails[]
  paymentSchedules: CheckoutPaymentSchedule[]
  enabledCardTypes: CardBrand[]
  preferredCard: CardDetails | null
  savedBankAccounts: BankAccountDetails[]
  preferredBankAccount: BankAccountDetails | null
  feature?: Feature
}

export const getEnrichedCardsAndBankAccounts = ({
  enabledCardTypes,
  paymentSchedules,
  preferredCard,
  preferredBankAccount,
  savedBankAccounts,
  savedCards,
  feature = Feature.PBI,
}: EnrichedCardsAndBankAccountsParams): EnrichedCardsAndBankAccounts => {
  const enrich = enrichCard({ enabledCardTypes, lastPaymentDate: lastPaymentDate(paymentSchedules), feature })
  const ePreferredCard = preferredCard === null ? null : enrich(preferredCard)
  const enrichedCards = savedCards?.map(enrich) ?? []
  const enrichedPreferredCard = selectPreferredCard(ePreferredCard, enrichedCards)
  const ePreferredBankAccount = preferredBankAccount === null ? null : enrichBankAccount(preferredBankAccount, enrichedPreferredCard)
  const enrichedBankAccounts = savedBankAccounts?.map((account) => enrichBankAccount(account, enrichedPreferredCard)) ?? []
  const enrichedPreferredBankAccount = selectPreferredBankAccount(ePreferredBankAccount, enrichedBankAccounts)

  return {
    enrichedCards,
    enrichedBankAccounts,
    enrichedPreferredBankAccount,
    enrichedPreferredCard,
  }
}
